import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "detail__card card-info" }
const _hoisted_2 = { class: "d-flex align-items-center gap-sm" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "card-info__title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "card-info__name" }
const _hoisted_8 = { class: "card-info__number" }
const _hoisted_9 = { class: "card-info__name" }
const _hoisted_10 = { class: "card-info__number d-flex align-items-start gap-1 flex-wrap" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = { key: 6 }
const _hoisted_18 = { class: "card-info__name" }
const _hoisted_19 = { class: "detail__flex" }
const _hoisted_20 = { class: "rate-info__mobile-label" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "detail__flex" }
const _hoisted_24 = { class: "rate-info__mobile-label" }
const _hoisted_25 = { class: "detail__flex" }
const _hoisted_26 = { class: "rate-info__mobile-label" }
const _hoisted_27 = { class: "sum-limits" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "detail__limits" }
const _hoisted_31 = { class: "rate-info__mobile-label" }
const _hoisted_32 = { class: "detail__limit" }
const _hoisted_33 = { class: "detail__limit-type" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "limits-values" }
const _hoisted_36 = { class: "detail__limit" }
const _hoisted_37 = { class: "detail__limit-type" }
const _hoisted_38 = ["title"]
const _hoisted_39 = { class: "limits-values" }
const _hoisted_40 = { class: "detail__limits count-limits" }
const _hoisted_41 = { class: "rate-info__mobile-label" }
const _hoisted_42 = { class: "detail__limit" }
const _hoisted_43 = { class: "detail__limit-type" }
const _hoisted_44 = ["title"]
const _hoisted_45 = { class: "limits-values" }
const _hoisted_46 = { class: "detail__limit" }
const _hoisted_47 = { class: "detail__limit-type" }
const _hoisted_48 = ["title"]
const _hoisted_49 = { class: "limits-values" }
const _hoisted_50 = { class: "detail__flex" }
const _hoisted_51 = { class: "rate-info__mobile-label" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "detail__flex" }
const _hoisted_54 = { class: "rate-info__mobile-label" }
const _hoisted_55 = { class: "switcher" }
const _hoisted_56 = { class: "switch" }
const _hoisted_57 = ["title"]
const _hoisted_58 = {
  class: "detail__controls",
  style: {}
}
const _hoisted_59 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_RequisiteFillStatusDot = _resolveComponent("RequisiteFillStatusDot")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_ReuseMinCapBadge = _resolveComponent("ReuseMinCapBadge")!
  const _component_RequisiteSumFill = _resolveComponent("RequisiteSumFill")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass({'requisite-row--child': _ctx.child})
  }, [
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.selectable)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "checkbox",
                class: "form-check-input flex-shrink-0",
                checked: _ctx.selected,
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', $event.target.checked)))
              }, null, 40, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_PayMethodIcon, {
              "icon-class": "pay-method-icon-xl",
              method: _ctx.item.method
            }, null, 8, ["method"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.item.currency), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(`payment_options.${_ctx.item.paymentOption}`)) + " ", 1),
                (_ctx.item.crossBorderCurrency)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.item.crossBorderCurrency), 1))
                  : _createCommentVNode("", true),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (_ctx.item.paymentSystem)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.helper.trans('payment_systems.' + _ctx.item.paymentSystem)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.crossBorderSwift(_ctx.item.raw))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.item.holderName), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.item.requisites), 1),
                    (_ctx.hasFrozenSums(_ctx.item))
                      ? (_openBlock(), _createBlock(_component_RequisiteFillStatusDot, {
                          key: 0,
                          item: _ctx.item,
                          class: "ms-1"
                        }, null, 8, ["item"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('labels.raw_field.swift')) + " " + _toDisplayString(_ctx.crossBorderSwift(_ctx.item.raw)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.item.paymentOption === _ctx.PaymentOption.SBP_QR && _ctx.item.requisites?.startsWith('http'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.item.requisites,
                          target: "_blank"
                        }, _toDisplayString(_ctx.helper.domain(_ctx.item.requisites)), 9, _hoisted_11))
                      : (_ctx.item.paymentOption === _ctx.PaymentOption.MANUAL_SBP_QR)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "—"))
                        : (_ctx.item.paymentOption === _ctx.PaymentOption.CLICK_UZ_QR && _ctx.item.requisites.startsWith('http'))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              href: _ctx.item.requisites,
                              target: "_blank"
                            }, _toDisplayString(_ctx.helper.trans('labels.my_click_uz')), 9, _hoisted_13))
                          : (_ctx.item.paymentOption === _ctx.PaymentOption.TIPS && _ctx.item.requisites.startsWith('http'))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 3,
                                href: _ctx.item.requisites,
                                target: "_blank"
                              }, _toDisplayString(_ctx.helper.domain(_ctx.item.requisites)), 9, _hoisted_14))
                            : (_ctx.item.paymentOption === _ctx.PaymentOption.VIET_QR)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _withDirectives((_openBlock(), _createElementBlock("span", {
                                    class: "font-monospace text-break flex-grow-1",
                                    style: {"min-width":"0"},
                                    title: _ctx.vietQrEmvFromRaw(_ctx.item.raw) || undefined
                                  }, [
                                    _createTextVNode(_toDisplayString(_ctx.truncateVietQrEmvDisplay(_ctx.vietQrEmvFromRaw(_ctx.item.raw)) || '—'), 1)
                                  ], 8, _hoisted_15)), [
                                    [
                                      _directive_b_tooltip,
                                      void 0,
                                      void 0,
                                      { hover: true }
                                    ]
                                  ]),
                                  (_ctx.vietQrEmvFromRaw(_ctx.item.raw))
                                    ? (_openBlock(), _createBlock(_component_copy_button, {
                                        key: 0,
                                        value: _ctx.vietQrEmvFromRaw(_ctx.item.raw),
                                        class: "flex-shrink-0 align-self-center"
                                      }, null, 8, ["value"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_ctx.item.paymentOption === _ctx.PaymentOption.IND_QR)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                    _withDirectives((_openBlock(), _createElementBlock("span", {
                                      class: "font-monospace text-break flex-grow-1",
                                      style: {"min-width":"0"},
                                      title: _ctx.qrisEmvFromRaw(_ctx.item.raw) || undefined
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.truncateVietQrEmvDisplay(_ctx.qrisEmvFromRaw(_ctx.item.raw)) || '—'), 1)
                                    ], 8, _hoisted_16)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                      ]
                                    ]),
                                    (_ctx.qrisEmvFromRaw(_ctx.item.raw))
                                      ? (_openBlock(), _createBlock(_component_copy_button, {
                                          key: 0,
                                          value: _ctx.qrisEmvFromRaw(_ctx.item.raw),
                                          class: "flex-shrink-0 align-self-center"
                                        }, null, 8, ["value"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.item.requisites), 1)),
                    (_ctx.hasFrozenSums(_ctx.item))
                      ? (_openBlock(), _createBlock(_component_RequisiteFillStatusDot, {
                          key: 7,
                          item: _ctx.item,
                          class: "align-self-center ms-1"
                        }, null, 8, ["item"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.item.holderName), 1)
                ], 64))
          ])
        ])
      ])
    ]),
    _createElementVNode("td", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('labels.device')), 1),
      (_ctx.item.device)
        ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
            _createElementVNode("img", {
              src: require(`@/apps/public/assets/img/device-${_ctx.item.device.status}.svg`)
            }, null, 8, _hoisted_22),
            _createTextVNode(" " + _toDisplayString(_ctx.item.device?.name), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('labels.req_group')), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.item.group?.name), 1)
    ]),
    _createElementVNode("td", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('labels.sum_limits')), 1),
      _createElementVNode("div", _hoisted_27, [
        (_ctx.item.minPayInDealSum)
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
              _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.from_limit', {sum: _ctx.numberFormatter.formatNumber(_ctx.item.minPayInDealSum), currency: _ctx.item.minPayInDealSum!.currency })), 1),
              _createVNode(_component_ReuseMinCapBadge, { item: _ctx.item }, null, 8, ["item"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.item.maxPayInDealSum)
          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.helper.trans('labels.to_limit', {sum: _ctx.numberFormatter.formatNumber(_ctx.item.maxPayInDealSum), currency: _ctx.item.maxPayInDealSum!.currency })), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('labels.volume_limits')), 1),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('labels.day')), 1),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "detail__limit-container",
            title: _ctx.sumTitle('labels.day', _ctx.item.dayTradesSum, _ctx.item.dayTradesFrozenSum)
          }, [
            (_ctx.hasFrozenSums(_ctx.item))
              ? (_openBlock(), _createBlock(_component_RequisiteSumFill, {
                  key: 0,
                  total: _ctx.item.dayTradesSum,
                  frozen: _ctx.item.dayTradesFrozenSum,
                  limit: _ctx.item.dayTradesSumLimit,
                  active: _ctx.item.isActive
                }, null, 8, ["total", "frozen", "limit", "active"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["detail__limit-count", {'bg-attention': _ctx.isDayLimitReached(_ctx.item)}]),
                  style: _normalizeStyle({width: (parseInt(_ctx.item.dayTradesSum.amount)/parseInt(_ctx.item.dayTradesSumLimit.amount) * 100) + '%'})
                }, null, 6)),
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.dayTradesSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.dayTradesSumLimit)), 1)
          ], 8, _hoisted_34)), [
            [
              _directive_b_tooltip,
              void 0,
              void 0,
              { hover: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('labels.month')), 1),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "detail__limit-container",
            title: _ctx.sumTitle('labels.month', _ctx.item.monthTradesSum, _ctx.item.monthTradesFrozenSum)
          }, [
            (_ctx.hasFrozenSums(_ctx.item))
              ? (_openBlock(), _createBlock(_component_RequisiteSumFill, {
                  key: 0,
                  total: _ctx.item.monthTradesSum,
                  frozen: _ctx.item.monthTradesFrozenSum,
                  limit: _ctx.item.monthTradesSumLimit,
                  active: _ctx.item.isActive
                }, null, 8, ["total", "frozen", "limit", "active"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["detail__limit-count", {'bg-attention': _ctx.isMonthLimitReached(_ctx.item)}]),
                  style: _normalizeStyle({width: (parseInt(_ctx.item.monthTradesSum.amount)/parseInt(_ctx.item.monthTradesSumLimit.amount) * 100) + '%'})
                }, null, 6)),
            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.monthTradesSum)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.monthTradesSumLimit)), 1)
          ], 8, _hoisted_38)), [
            [
              _directive_b_tooltip,
              void 0,
              void 0,
              { hover: true }
            ]
          ])
        ])
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('labels.count_limits')), 1),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('labels.day')), 1),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "detail__limit-container",
            title: _ctx.$t('labels.day')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["detail__limit-count", {'bg-attention': _ctx.item.dayTradesCountLimit > 0 && _ctx.item.dayTradesCount/_ctx.item.dayTradesCountLimit >= 0.9}]),
              style: _normalizeStyle({width: (_ctx.item.dayTradesCountLimit === 0 ? 0 : parseInt(_ctx.item.dayTradesCount)/parseInt(_ctx.item.dayTradesCountLimit) * 100) + '%'})
            }, null, 6),
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.dayTradesCount)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.dayTradesCountLimit)), 1)
          ], 8, _hoisted_44)), [
            [
              _directive_b_tooltip,
              void 0,
              void 0,
              { hover: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('labels.month')), 1),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "detail__limit-container",
            title: _ctx.$t('labels.month')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["detail__limit-count", {'bg-attention': _ctx.item.monthTradesCountLimit > 0 && _ctx.item.monthTradesCount/_ctx.item.monthTradesCountLimit >= 0.9}]),
              style: _normalizeStyle({width: (_ctx.item.monthTradesCountLimit === 0 ? 0 : parseInt(_ctx.item.monthTradesCount)/parseInt(_ctx.item.monthTradesCountLimit) * 100) + '%'})
            }, null, 6),
            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.monthTradesCount)) + "/" + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.monthTradesCountLimit)), 1)
          ], 8, _hoisted_48)), [
            [
              _directive_b_tooltip,
              void 0,
              void 0,
              { hover: true }
            ]
          ])
        ])
      ])
    ]),
    _createElementVNode("td", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('labels.concurrent_trader_count_short')), 1),
      (_ctx.item.concurrentTradesCount)
        ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.item.concurrentTradesCount)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('labels.status')), 1),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("label", _hoisted_56, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            title: _ctx.item.isActive ? _ctx.helper.trans('requisites.active') : _ctx.helper.trans('requisites.inactive'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.isActive) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle', $event, _ctx.item)))
          }, null, 40, _hoisted_57), [
            [
              _directive_b_tooltip,
              void 0,
              void 0,
              { hover: true }
            ],
            [_vModelCheckbox, _ctx.item.isActive]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "slider" }, null, -1))
        ])
      ])
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_58, [
        (_ctx.item.device)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('showLogs', _ctx.item.device)), ["prevent"])),
              class: "btn detail__btn"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M3.505 2.365C5.32653 2.12142 7.16226 1.99948 9 2C10.863 2 12.697 2.124 14.495 2.365C15.742 2.532 16.675 3.473 16.93 4.633C16.7394 4.59745 16.5466 4.57441 16.353 4.564C14.7855 4.47838 13.2145 4.47838 11.647 4.564C9.229 4.696 7.5 6.727 7.5 8.998V11.238C7.5 12.651 8.17 13.973 9.26 14.8L6.28 17.78C6.17511 17.8848 6.04153 17.9561 5.89614 17.985C5.75074 18.0139 5.60004 17.999 5.46308 17.9423C5.32611 17.8856 5.20903 17.7895 5.12661 17.6663C5.04419 17.5431 5.00013 17.3982 5 17.25V13.807C4.499 13.759 4 13.701 3.505 13.635C2.033 13.438 1 12.162 1 10.72V5.28C1 3.839 2.033 2.562 3.505 2.365Z",
                  fill: "#F7F9FC"
                }),
                _createElementVNode("path", {
                  d: "M14 6C13.238 6 12.48 6.02 11.729 6.062C10.157 6.148 9 7.472 9 8.998V11.238C9 12.757 10.147 14.077 11.71 14.173C11.924 14.186 12.138 14.197 12.352 14.207C12.552 14.216 12.737 14.297 12.87 14.431L15.22 16.781C15.3249 16.8858 15.4586 16.9572 15.6041 16.986C15.7496 17.0149 15.9004 16.9999 16.0374 16.9431C16.1744 16.8863 16.2915 16.7901 16.3738 16.6667C16.4562 16.5433 16.5001 16.3983 16.5 16.25V14.18C17.953 13.985 19 12.717 19 11.265V8.998C19 7.472 17.843 6.148 16.271 6.062C15.5147 6.02068 14.7574 6.00001 14 6Z",
                  fill: "#F7F9FC"
                })
              ], -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.item.isWhiteTriangle && _ctx.store.getters.getAppData?.fraudexEnabled)
          ? _withDirectives((_openBlock(), _createElementBlock("a", {
              key: 1,
              href: "#",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('fraudexFeedback', _ctx.item)), ["prevent"])),
              title: _ctx.$t('fraudex.leave_feedback'),
              class: "btn detail__btn"
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M2 2C1.44772 2 1 2.44772 1 3V13C1 13.5523 1.44772 14 2 14H4V17.5858C4 17.851 4.10536 18.1054 4.29289 18.2929L7.70711 21.7071C7.89464 21.8946 8.149 22 8.41421 22H18C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H2Z",
                  fill: "#F7F9FC"
                }),
                _createElementVNode("path", {
                  d: "M5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7Z",
                  fill: "white"
                }),
                _createElementVNode("path", {
                  d: "M5 10C5 9.44772 5.44772 9 6 9H11C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11H6C5.44772 11 5 10.5523 5 10Z",
                  fill: "white"
                })
              ], -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('fraudex.leave_feedback')), 1)
            ], 8, _hoisted_59)), [
              [
                _directive_b_tooltip,
                void 0,
                void 0,
                { hover: true }
              ]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('edit', _ctx.item)), ["prevent"])),
          class: "btn detail__btn detail__redact"
        }, _cache[11] || (_cache[11] = [
          _createElementVNode("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M1.43302 17.9172L2.69502 14.7622C2.89605 14.2592 3.19714 13.8023 3.58002 13.4192L13.9898 3.01046L16.9903 6.01046L6.58102 16.4192C6.19799 16.8025 5.74108 17.1039 5.23802 17.3052L2.08302 18.5672C1.99216 18.6036 1.89262 18.6125 1.79674 18.5928C1.70087 18.5731 1.61287 18.5258 1.54366 18.4566C1.47446 18.3874 1.42708 18.2994 1.40742 18.2035C1.38775 18.1076 1.39665 18.0081 1.43302 17.9172Z",
              fill: "#F7F9FC"
            }),
            _createElementVNode("path", {
              d: "M18.1213 4.0012C18.1213 4.56381 17.8978 5.10338 17.5 5.5012L14.5 2.5012C14.8978 2.10338 15.4374 1.87988 16 1.87988C16.5626 1.87988 17.1022 2.10338 17.5 2.5012C17.8978 2.89903 18.1213 3.43859 18.1213 4.0012Z",
              fill: "#F7F9FC"
            })
          ], -1)
        ])),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('remove', _ctx.item)), ["prevent"])),
          class: "btn detail__btn detail__remove"
        }, _cache[12] || (_cache[12] = [
          _createElementVNode("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M2 3C1.73478 3 1.48043 3.10536 1.29289 3.29289C1.10536 3.48043 1 3.73478 1 4V5C1 5.26522 1.10536 5.51957 1.29289 5.70711C1.48043 5.89464 1.73478 6 2 6H18C18.2652 6 18.5196 5.89464 18.7071 5.70711C18.8946 5.51957 19 5.26522 19 5V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H2Z",
              fill: "#F7F9FC"
            }),
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M2 7.5H18L17.189 15.21C17.1371 15.7015 16.905 16.1564 16.5376 16.487C16.1701 16.8175 15.6933 17.0003 15.199 17H4.802C4.30774 17.0003 3.8309 16.8175 3.46343 16.487C3.09596 16.1564 2.8639 15.7015 2.812 15.21L2 7.5ZM7.22 9.22C7.36063 9.07955 7.55125 9.00066 7.75 9.00066C7.94875 9.00066 8.13937 9.07955 8.28 9.22L10 10.94L11.72 9.22C11.7887 9.14631 11.8715 9.08721 11.9635 9.04622C12.0555 9.00523 12.1548 8.98318 12.2555 8.98141C12.3562 8.97963 12.4562 8.99816 12.5496 9.03588C12.643 9.0736 12.7278 9.12974 12.799 9.20096C12.8703 9.27218 12.9264 9.35701 12.9641 9.4504C13.0018 9.54379 13.0204 9.64382 13.0186 9.74452C13.0168 9.84522 12.9948 9.94454 12.9538 10.0365C12.9128 10.1285 12.8537 10.2113 12.78 10.28L11.06 12L12.78 13.72C12.8537 13.7887 12.9128 13.8715 12.9538 13.9635C12.9948 14.0555 13.0168 14.1548 13.0186 14.2555C13.0204 14.3562 13.0018 14.4562 12.9641 14.5496C12.9264 14.643 12.8703 14.7278 12.799 14.799C12.7278 14.8703 12.643 14.9264 12.5496 14.9641C12.4562 15.0018 12.3562 15.0204 12.2555 15.0186C12.1548 15.0168 12.0555 14.9948 11.9635 14.9538C11.8715 14.9128 11.7887 14.8537 11.72 14.78L10 13.06L8.28 14.78C8.13783 14.9125 7.94978 14.9846 7.75548 14.9812C7.56118 14.9777 7.37579 14.899 7.23838 14.7616C7.10097 14.6242 7.02225 14.4388 7.01883 14.2445C7.0154 14.0502 7.08752 13.8622 7.22 13.72L8.94 12L7.22 10.28C7.07955 10.1394 7.00066 9.94875 7.00066 9.75C7.00066 9.55125 7.07955 9.36063 7.22 9.22Z",
              fill: "#F7F9FC"
            })
          ], -1)
        ]))
      ])
    ])
  ], 2))
}